<template>
    <router-view />
</template>

<script>
import {importI18n} from "@/modules/i18n/i18n";
import {inject} from 'vue';
import en from "@/modules/i18n/en";
import zh from "@/modules/i18n/zh";
import config from "@/config/config.json";

export default {
  setup(props, context) {

      const i18n = inject('i18n');
      importI18n(i18n)
      console.log("@app; process.env.VUE_APP_MODE:");
      console.log(process.env.VUE_APP_MODE);
      console.log("@app; process.env.VUE_APP_ROUTER_BASE:");
      console.log(process.env. VUE_APP_ROUTER_BASE);
      console.log("app; process.env.VUE_APP_MPMS_DOMAIN:");
      console.log(process.env.VUE_APP_MPMS_DOMAIN);
  }
}
</script>

<style scoped lang="scss">

</style>
